export enum Size {
    small = "small",
    normal = "normal",
    large = "large"
}